<template>
  <main v-if="loadError" class="container py-5">
    <h1 class="h2">{{ loadError }}</h1>
    <router-link to="/marketplace">Каталог товаров</router-link>
  </main>
  <div v-if="product" class="marketplace mx-md-4 my-md-4">
    <h1 class="d-none d-md-block">{{ product.name }}</h1>
    <div class="marketplace-header d-lg-flex mt-md-4 pt-md-4 md-0 pt-0 d-md-block">
      <div class="marketplace-image" style="cursor: zoom-in" @click="openLightbox()">
        <img :src="mainImg" :alt="product.name" />
      </div>
      <div class="my-carousel">
        <Swiper
          :slides-per-view="1"
          :space-between="10"
          :pagination="{ clickable: true }"
          loop
          autoplay
          :modules="[Pagination, Autoplay]"
        >
          <SwiperSlide v-for="(img, index) in product.images" :key="index">
            <img :src="img.image" :alt="product.name" class="swiper-slide-img" @click="openLightbox(index)" />
          </SwiperSlide>
        </Swiper>
      </div>
      <div class="marketplace-info mt-md-0 mt-4">
        <h2 class="marketplace-price mobile">
          <template v-if="product.sale_price && Number(product.sale_price) > 0">
            {{ formatPrice(product.sale_price) }}
          </template>
          <span
            class="ms-2"
            :class="{
              sale: product.sale_price && Number(product.sale_price) > 0,
            }"
          >
            {{ formatPrice(product.price) }}
          </span>
        </h2>
        <h3 class="d-md-none d-block">{{ product.name }}</h3>
        <div class="rating">
          <span v-if="!product.rating" class="stars me-2">★</span>
          <span v-for="star in product.rating" :key="star" class="stars me-2">★</span>
          <span class="ms-2">{{ product.rating }}</span>
        </div>
        <div class="marketplace-details row gy-2 gap-3">
          <img
            v-for="(img, index) in product.images"
            :key="index"
            class="small_imgs"
            :src="img.image"
            :alt="product.name"
            @click="mainImg = img.image"
          />
        </div>
        <h3>О товаре</h3>
        <table class="marketplace-specs">
          <tr>
            <td><span>Тип</span></td>
            <td>{{ product.category?.name }}</td>
          </tr>
        </table>
      </div>
      <div class="col mt-md-0 mt-4">
        <div class="mobile-buttons">
          <div v-if="quantityInCart === 0">
            <button class="primary-button black-button mt-3 w-50" @click.stop="addToCart">Добавить в корзину</button>
          </div>
          <div v-else class="counter-group mt-3 w-50">
            <button class="counter-btn" @click.stop="updateCount(-1)">–</button>
            <span class="quantity-text">{{ quantityInCart }}</span>
            <button class="counter-btn" @click.stop="updateCount(1)">+</button>
          </div>
          <button class="primary-button black-button mt-3 w-100" @click.stop="createChat">Написать продавцу</button>
        </div>
        <div class="marketplace-card d-md-block d-none">
          <div class="d-flex justify-content-between">
            <h3 class="marketplace-price">
              <template v-if="product.sale_price && Number(product.sale_price) > 0">
                {{ formatPrice(product.sale_price) }}
              </template>
              <span
                class="ms-2"
                :class="{
                  sale: product.sale_price && Number(product.sale_price) > 0,
                }"
              >
                {{ formatPrice(product.price) }}
              </span>
            </h3>
            <button class="like-button" :class="{ liked: likedProduct === true }" @click="clickLike">
              <svg width="35" height="30" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.18054 13.5549L7.17983 13.5542C5.11017 11.6365 3.43202 10.0786 2.26545 8.62023C1.10468 7.16915 0.5 5.8759 0.5 4.49591C0.5 2.23655 2.22166 0.5 4.4 0.5C5.6368 0.5 6.83521 1.09095 7.61714 2.02186L8 2.47767L8.38286 2.02186C9.16479 1.09095 10.3632 0.5 11.6 0.5C13.7783 0.5 15.5 2.23655 15.5 4.49591C15.5 5.8759 14.8953 7.16915 13.7346 8.62023C12.568 10.0786 10.8898 11.6365 8.82017 13.5542L8.81946 13.5549L8 14.3171L7.18054 13.5549Z"
                  stroke="#313132"
                />
              </svg>
            </button>
          </div>
          <div v-if="quantityInCart === 0">
            <button class="black-button mt-3 w-50" @click.stop="addToCart">Добавить в корзину</button>
          </div>
          <div
            v-else
            class="counter-group d-flex align-items-center justify-content-between p-2 mt-3 w-50"
            style="background: #f8f9fa; border-radius: 15px"
          >
            <button class="counter-btn-large" @click.stop="updateCount(-1)">–</button>
            <span class="h4 mb-0">{{ quantityInCart }}</span>
            <button class="counter-btn-large" @click.stop="updateCount(1)">+</button>
          </div>
          <button class="primary-button black-button mt-3 w-50" @click.stop="createChat">Написать продавцу</button>
        </div>
        <div v-if="product.company" class="marketplace-card col mt-4">
          <div class="seller-info d-flex justify-content-between align-items-center" @click="goToCompany(company.inn)">
            <p class="mb-0">{{ product.company_name }}</p>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.332928 0.292786C0.122023 0.480314 0.0035429 0.734622 0.0035429 0.999786C0.0035429 1.26495 0.122023 1.51926 0.332928 1.70679L5.90168 6.65679L0.332928 11.6068C0.128 11.7954 0.0146065 12.048 0.01717 12.3102C0.0197334 12.5724 0.138048 12.8232 0.346632 13.0086C0.555216 13.194 0.83738 13.2992 1.13235 13.3015C1.42732 13.3037 1.7115 13.2029 1.92368 13.0208L8.2878 7.36379C8.49871 7.17626 8.61719 6.92195 8.61719 6.65679C8.61719 6.39162 8.49871 6.13731 8.2878 5.94979L1.92368 0.292786C1.71271 0.105315 1.42661 0 1.1283 0C0.829993 0 0.543897 0.105315 0.332928 0.292786Z"
                fill="#3E3E3E"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="marketplace-description mt-4">
      <h3>Описание</h3>
      <p class="mt-4" v-html="product.description"></p>
    </div>

    <div class="divider"></div>
    <div class="marketplace-specs-section d-md-flex mt-4">
      <div class="specs col-md-6">
        <h3>Характеристика</h3>
        <table class="mt-4 w-100">
          <tr>
            <td>Артикул</td>
            <td></td>
          </tr>
          <tr>
            <td>Тип товара</td>
            <td>{{ product.category?.name }}</td>
          </tr>
          <tr>
            <td>Производитель</td>
            <td>{{ product.company_name }}</td>
          </tr>
          <tr>
            <td>Материал</td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="seller-details col-md-6 mb-4 mt-md-0 mt-4">
        <h3>О продавце</h3>
        <table class="mt-4 w-100">
          <tr>
            <td>Название</td>
            <td>{{ company?.name }}</td>
          </tr>
          <tr>
            <td>Генеральный директор</td>
            <td>{{ company?.directors[0]?.fio }}</td>
          </tr>
          <tr>
            <td>ОГРН</td>
            <td>{{ company?.ogrn }}</td>
          </tr>
          <tr>
            <td>ИНН</td>
            <td>{{ company?.inn }}</td>
          </tr>
          <tr>
            <td>Адрес</td>
            <td>{{ company?.legal_adress?.adress }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="divider"></div>

    <div class="reviews-section">
      <h3 class="reviews-title mb-4">
        <span translate="yes">Отзывы о товаре</span>
        <span v-if="product?.comments" class="reviews-count">
          {{ product.comments.length }}
        </span>
      </h3>
      <div class="reviews mt-4">
        <template v-if="product?.comments && product.comments.length">
          <div v-for="comment in product.comments" :key="comment.id" class="review-item py-4 border-bottom">
            <div class="d-flex align-items-start">
              <div class="review-avatar-container me-3">
                <img v-if="comment.user.avatar" :src="comment.user.avatar" alt="avatar" class="avatar-img" />
                <div v-else class="avatar-letter">
                  {{ comment.user.full_name.charAt(0).toUpperCase() }}
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h5 class="review-author-name mb-0">
                    {{ comment.user.full_name }}
                  </h5>

                  <div class="d-flex align-items-center review-meta">
                    <span class="review-date me-3">{{ formatDate(comment.time_create) }}</span>
                    <div class="stars-rating">
                      <span v-for="star in 5" :key="star" class="star" :class="{ filled: star <= comment.stars }"
                        >★</span
                      >
                    </div>
                  </div>
                </div>
                <p class="review-text-content mb-0">{{ comment.content }}</p>
              </div>
            </div>
          </div>
        </template>
        <p v-else class="text-muted mt-4" translate="yes">Отзывов пока нет. Будьте первым!</p>
      </div>
    </div>
  </div>
  <div id="lightboxModal" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content bg-transparent border-0">
        <div class="modal-body p-0 position-relative">
          <button
            type="button"
            class="btn-close btn-close-white position-absolute top-0 end-0 m-3"
            data-bs-dismiss="modal"
            style="z-index: 100"
          ></button>
          <Swiper
            v-if="product?.images"
            :slides-per-view="1"
            :space-between="30"
            :navigation="true"
            :pagination="{ clickable: true, type: 'fraction' }"
            :modules="[Pagination, Navigation]"
            class="lightbox-swiper"
            @swiper="onLightboxSwiper"
          >
            <SwiperSlide v-for="(img, index) in product.images" :key="index">
              <div class="d-flex align-items-center justify-content-center" style="height: 80vh">
                <img :src="img.image" class="img-fluid rounded" style="max-height: 100%; object-fit: contain" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, onMounted, ref, computed } from 'vue';
  import MarketplaceService from '@/services/marketplace';
  import ChatRoomService from '@/services/chatRoom';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import moment from 'moment';

  // import { Swiper, SwiperSlide } from "swiper/vue"; // Correct path for Swiper 8+
  import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
  import 'swiper/swiper-bundle.css';
  import 'swiper/swiper.min.css';

  import 'swiper/modules/navigation/navigation.min.css';
  import 'swiper/modules/pagination/pagination.min.css';
  import { Pagination, Navigation, Autoplay } from 'swiper';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    name: 'MarketplaceItem',
    components: {
      Swiper,
      SwiperSlide,
    },
    setup() {
      const store = useStore();
      const route = useRoute();
      const router = useRouter();
      const product = ref(null);
      const loadError = ref('');
      const company = ref(null);
      const productAdded = ref(false);
      const mainImg = ref(null);

      const likedProduct = ref(false);
      const selectRating = ref(0);
      const commentText = ref('');
      const parentComment = ref(null);
      const lightboxInstance = ref(null);
      const isLoggedIn = computed(() => store.state.auth.status.loggedIn);

      // 1. Вычисляем количество именно этого товара в корзине
      const quantityInCart = computed(() => {
        if (!product.value) return 0;
        const item = store.state.user.cartList?.find((i) => i.product.id === product.value.id);
        return item ? item.quantity : 0;
      });

      // 2. Универсальная функция для +1 или -1
      const updateCount = async (delta) => {
        if (!isLoggedIn.value) {
          openModal();
          return;
        }
        try {
          await MarketplaceService.addToBasket(product.value.id, delta);
          // Обновляем список корзины в сторе (это сразу изменит quantityInCart)
          await store.dispatch('user/getCartItems');
        } catch (e) {
          store.dispatch('notifications/triggerToast', {
            message: 'Не удалось обновить корзину',
            type: 'error',
          });
        }
      };

      // 3. Старая функция теперь просто вызывает updateCount
      const addToCart = async () => {
        await updateCount(1);
        store.dispatch('notifications/triggerToast', {
          message: 'Товар добавлен в корзину',
          type: 'success',
        });
      };

      const clickLike = async () => {
        if (isLoggedIn.value) {
          if (!likedProduct.value) {
            await MarketplaceService.addToFavorite(product.value.id);
            likedProduct.value = true;
          } else {
            await MarketplaceService.removeFromFavorite(product.value.id);
            likedProduct.value = false;
          }
        } else {
          openModal();
        }
      };

      // const toggleScroll = (isFixed) => {
      //   if (isFixed) {
      //     document.body.style.overflow = "hidden";
      //     document.documentElement.style.overflow = "hidden";
      //   } else {
      //     document.body.style.overflow = "";
      //     document.documentElement.style.overflow = "";
      //   }
      // };

      const onLightboxSwiper = (swiper) => {
        lightboxInstance.value = swiper;
      };

      const openLightbox = (index = null) => {
        let startIndex = 0;

        if (index !== null) {
          startIndex = index;
        } else {
          startIndex = product.value.images.findIndex((img) => img.image === mainImg.value);
        }

        const modalElement = document.getElementById('lightboxModal');
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.show();

          setTimeout(() => {
            if (lightboxInstance.value) {
              lightboxInstance.value.slideTo(startIndex, 0);
            }
          }, 200);
        }
      };

      const sendComment = () => {
        if ((selectRating.value !== 0 || parentComment.value) && commentText.value !== '') {
          MarketplaceService.sendComment(selectRating.value, commentText.value, product.value.id, parentComment.value);
          MarketplaceService.show(route.params.id).then((res) => {
            product.value = res;
          });
        }
      };

      const createChat = async () => {
        if (isLoggedIn.value) {
          const room = await ChatRoomService.addRoom({
            product: product.value.id,
          });
          store.dispatch('chats/SelectChat', {
            selectId: room.id,
            selectSlug: room.slug,
          });

          router.push('/profile/messages');
        } else {
          openModal();
        }
      };

      const openModal = () => {
        const loginModal = new Modal(document.getElementById('authModal'));
        loginModal.show();
      };

      const goToCompany = () => {
        router.push({
          name: 'Company',
          params: { id: product.value.company },
        });
      };

      const formatPrice = (price) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(price);
      };

      onMounted(async () => {
        await MarketplaceService.show(route.params.id)
          .then((res) => {
            product.value = res;
            likedProduct.value = product.value.is_liked;
            if (product.value.images?.length) {
              mainImg.value = product.value.images[0]?.image;
            } else {
              mainImg.value = require('@/assets/images/logo_info.svg');
            }
          })
          .catch((error) => {
            loadError.value =
              error.response?.status === 404 ? 'Товар не найден' : 'Не удалось загрузить товар. Обновите страницу.';
          });
        if (product.value) {
          const companyId = product.value.company;
          if (companyId) {
            company.value = await store.dispatch('companies/getById', companyId);
          }
        }
      });

      const formatDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
      };

      return {
        company,
        loadError,
        product,
        likedProduct,
        productAdded,
        mainImg,
        goToCompany,
        addToCart,
        clickLike,
        sendComment,
        formatDate,
        createChat,
        formatPrice,
        Pagination,
        Navigation,
        Autoplay,
        onLightboxSwiper,
        openLightbox,
        quantityInCart,
        updateCount,
      };
    },
  });
</script>

<style scoped lang="scss">
  @import '@/assets/styles/marketplace';

  .swiper-slide-img {
    width: 100%;
    height: 20rem;
    object-fit: contain;
  }

  .swiper-button-next {
    color: #3e3e3e;

    &::after {
      color: #3e3e3e;
      font-size: 20px;

      border-color: #3e3e3e;

      content: '';
    }
  }

  .swiper-button-prev {
    color: #3e3e3e;

    &::after {
      color: #3e3e3e;
      font-size: 20px;

      border-color: #3e3e3e;

      content: '';
    }
  }

  /* stylelint-disable-next-line selector-id-pattern */
  #lightboxModal {
    background-color: rgb(0 0 0 / 90%);

    .modal-dialog {
      max-width: 100vw;
      margin: 0;
    }

    /* Настройка кнопок навигации Swiper в модалке */
    .swiper-button-next,
    .swiper-button-prev {
      color: white;

      &::after {
        font-size: 24px;
      }
    }

    .swiper-pagination {
      bottom: 20px;

      color: white;
    }
  }

  @media (max-width: 768px) {
    .lightbox-swiper {
      width: 100vw;
      height: 70vh;
    }
  }

  .counter-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 48px;
    padding: 0 10px;

    background-color: #f7f7f7;
    border: 2px solid #3e3e3e;
    border-radius: 10px;

    .counter-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;

      color: #fff;
      font-weight: bold;
      font-size: 20px;

      background-color: #3e3e3e;
      border: none;
      border-radius: 8px;

      transition: opacity 0.2s;

      &:active {
        opacity: 0.7;
      }
    }

    .quantity-text {
      color: #3e3e3e;
      font-weight: 800;
      font-size: 18px;
    }
  }

  .reviews-title {
    display: flex;
    align-items: flex-start;

    color: #3e3e3e;
    font-weight: 700;
    font-size: 20px;

    .reviews-count {
      position: relative;
      top: -5px;

      margin-left: 4px;

      color: #a3a3a3;
      font-weight: 400;
      font-size: 14px;
    }
  }

  .review-item {
    &:last-child {
      border-bottom: none !important;
    }

    // Стили аватара
    .review-avatar-container {
      flex-shrink: 0;
      width: 50px;
      height: 50px;

      .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;

        border-radius: 50%;
      }

      .avatar-letter {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        color: #0066ce;
        font-weight: 700;
        font-size: 20px;

        background-color: #eef7ff; // Светло-голубой фон как на скрине
        border-radius: 50%;
      }
    }

    // Имя пользователя
    .review-author-name {
      color: #3e3e3e;
      font-weight: 700;
      font-size: 16px;
    }

    // Дата
    .review-date {
      color: #8a8a8a; // Серый цвет даты
      font-size: 14px;
    }

    // Звезды
    .stars-rating {
      display: flex;
      gap: 2px;

      .star {
        color: #e0e0e0; // Цвет пустой звезды
        font-size: 18px;

        &.filled {
          color: #ffb800; // Желтый цвет закрашенной звезды
        }
      }
    }

    // Текст отзыва
    .review-text-content {
      margin-top: 5px;

      color: #3e3e3e;
      font-size: 15px;
      line-height: 1.5;
    }
  }

  // Адаптив для мобилок (чтобы дата и звезды не прилипали к имени)
  @media (max-width: 576px) {
    .review-meta {
      justify-content: space-between;
      width: 100%;
      margin-top: 5px;
    }
  }
</style>
